import React, { useEffect, useState } from 'react';
import StaffLayout from '../../layouts/StaffLayout';
import { Box, Typography, Grid, Paper, CircularProgress } from '@mui/material';
import api from '../../services/api';

function StaffStoragePage() {
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    api.get('/api/storage')
      .then(res => setFiles(Array.isArray(res.data) ? res.data : []))
      .catch(err => setError(err.response?.data?.error || 'Failed to fetch files'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <StaffLayout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Storage Management
        </Typography>
        <Paper sx={{ p: 3, borderRadius: 3, mb: 3 }}>
          <Typography variant="body2" color="text.secondary" mb={2}>
            All files assigned to staff are listed below.
          </Typography>
          {error && <Typography color="error" mb={2}>{error}</Typography>}
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              {files.length === 0 && (
                <Grid item xs={12}><Typography>No files found.</Typography></Grid>
              )}
              {files.map((f) => (
                <Grid item xs={12} sm={6} md={4} key={f._id}>
                  <Paper sx={{ p: 2.2, borderRadius: 3, boxShadow: 3, mb: 2, background: '#fcfcff', border: '1.5px solid #e0e0e0' }}>
                    <Typography variant="subtitle1" fontWeight={700} color="primary.main" sx={{ fontSize: 16.5 }}>
                      {f.name || f.filename || 'N/A'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom sx={{ fontSize: 13.5, mt: 0.2 }}>
                      <b>Type:</b> {f.type || 'N/A'}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 0.2, fontSize: 13.2 }}>
                      <b>Size:</b> {f.size ? `${f.size} bytes` : 'N/A'}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
        </Paper>
      </Box>
    </StaffLayout>
  );
}

export default StaffStoragePage;
